import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "Attachments" */ './lazyIndex')
);

export const AttachmentView = createLazyComponent(lazyModule, m => m.AttachmentView);

export const lazyGetContextMenus = new LazyImport(lazyModule, m => m.getContextMenus);

export { default as datapoints } from './datapoints';
export { SurfaceAction } from './types/SurfaceAction';
export type { AttachmentModel } from 'owa-attachment-model-store';
export type { AttachmentFullViewState } from 'owa-attachment-full-data';
export { default as AttachmentSurfaceActionButton } from './components/SurfaceActions/AttachmentSurfaceActionButton';
export { EditInBrowserButtonLabel, EditInDesktopButtonLabel } from './strings.locstring.json';
